export const MIN_PRICE = "MIN_PRICE";
export const MAX_PRICE = "MAX_PRICE";
export const SORT_BY = "SORT_BY";
export const RATING = "RATING";
export const CLEAR_FILTERS = "CLEAR_FILTERS";
